var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.haveInfo)?_c('AppValidationAlert',{attrs:{"check-valid":_vm.status,"valid":_vm.$t(
      'horses:appshow.HorseAccountStatus.Active.label',
      'Active',
      'Label for active horse account status'
    ),"invalid":_vm.$t(
      'horses:appshow.HorseAccountStatus.Inactive.label',
      'Inactive',
      'Label for inactive horse account status'
    )}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }